(function () {
  'use strict';

  var MODAL_ID = 'ac-cart-modal';
  var BODY_CLASS = 'ac-modal-open';
  var OPEN_CLASS = 'is-open';
  var PARTS = ['.ac-modal__panel', '.ac-modal__thumb', '.ac-modal__name', '.ac-modal__variant', '.ac-modal__price'];
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastFocused = null;

  function root() {
    return document.getElementById(MODAL_ID);
  }

  function isUsable() {
    var el = root();
    if (!el) return false;
    for (var i = 0; i < PARTS.length; i++) {
      if (!el.querySelector(PARTS[i])) return false;
    }
    return true;
  }

  function isOpen() {
    var el = root();
    return !!el && el.classList.contains(OPEN_CLASS);
  }

  function sizedImage(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (e) {
      return url;
    }
  }

  function formatPrice(item) {
    var cents =
      typeof item.presentment_price === 'number' ? Math.round(item.presentment_price * 100) : Number(item.price);

    if (!isFinite(cents)) return '';

    var theme = window.FoxTheme;
    if (theme && theme.utils && typeof theme.utils.formatMoney === 'function') {
      return theme.utils.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }

    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (e) {
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }
  }

  function variantLabel(item) {
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    return item.variant_title.split(' / ').join(', ');
  }

  function render(el, item) {
    var title = item.product_title || item.title || '';
    var thumb = el.querySelector('.ac-modal__thumb');

    thumb.src = sizedImage(item.image || item.featured_image, 144);
    thumb.alt = title;
    el.querySelector('.ac-modal__name').textContent = title;
    el.querySelector('.ac-modal__variant').textContent = variantLabel(item);
    el.querySelector('.ac-modal__price').textContent = formatPrice(item);
  }

  function trapTab(e) {
    var el = root();
    var panel = el && el.querySelector('.ac-modal__panel');
    var items = panel ? panel.querySelectorAll(FOCUSABLE) : [];
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && (active === first || !panel.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      hide();
      return;
    }
    if (e.key === 'Tab') trapTab(e);
  }

  function onClick(e) {
    if (e.target.closest('[data-ac-action="close"]') || !e.target.closest('.ac-modal__panel')) {
      e.preventDefault();
      hide();
    }
  }

  function bind() {
    var el = root();
    if (!el || el.dataset.acBound) return;
    el.dataset.acBound = '1';
    el.addEventListener('click', onClick);
  }

  function show(item, opener) {
    if (!isUsable()) return false;
    var el = root();
    bind();

    render(el, item || {});

    lastFocused = opener || document.activeElement;
    el.classList.add(OPEN_CLASS);
    el.removeAttribute('aria-hidden');
    document.body.classList.add(BODY_CLASS);

    var close = el.querySelector('.ac-modal__close');
    if (close) close.focus({ preventScroll: true });
    return true;
  }

  function hide() {
    var el = root();
    if (!el) return;

    el.classList.remove(OPEN_CLASS);
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_CLASS);

    if (lastFocused && typeof lastFocused.focus === 'function' && lastFocused.isConnected) {
      lastFocused.focus({ preventScroll: true });
    }
    lastFocused = null;
  }

  document.addEventListener('keydown', onKeydown, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.ACCartModal = {
    canShow: isUsable,
    show: show,
    hide: hide,
    isOpen: isOpen,
  };
})();
